import { createContext, FunctionComponent, useContext, useRef, useState } from 'react';
import { InstructionStep } from '../interfaces';
import { OmitMethods } from '../types';

interface NavigationContextI {
	map?: React.MutableRefObject<mapboxgl.Map | undefined>;
	steps?: Array<InstructionStep>;
	setSteps: (steps: Array<InstructionStep>) => void;
}

const initialState: OmitMethods<NavigationContextI> = {};

export const NavigationContext = createContext(initialState as NavigationContextI);

export const NavigationProvider: FunctionComponent = ({ children }) => {
	const map = useRef<mapboxgl.Map>();
	const [steps, setSteps] = useState<Array<InstructionStep>>();
	return <NavigationContext.Provider value={{ steps, setSteps, map }}>{children}</NavigationContext.Provider>;
};

export function useNavigation() {
	return useContext(NavigationContext);
}
